// Is the text_draft_json deserializable?
export const isDecodableRDCS = (rdcs?: any) => {
  return rdcs != null && Array.isArray(rdcs?.blocks) && rdcs?.entityMap != null;
};
